module.exports = __webpack_public_path__ + "static/media/access-account.36538f66.svg";